import { useMemo } from 'react';
import { useSelector } from 'store';
import useMyRole from './useMyRole';
import { ROLE_ACTIONS, RoleActionEnum, RoleActionValues } from 'types/layout';

const useIsAllowed = (action: RoleActionEnum) => {
    const roleId = useMyRole();
    const { actionData, selectedItem } = useSelector((store) => store.menu);

    const isAllowed = useMemo(
        () =>
            actionData
                .find((el) => Number(el.menuItem.id) === Number(selectedItem) && Number(el.role.id) === (roleId as number))
                ?.menuItemActions.find((el) => (el.name as RoleActionValues) === ROLE_ACTIONS[action])?.enabled,
        [action, actionData, roleId, selectedItem]
    );

    return {
        isAllowed
    };
};

export default useIsAllowed;
